import AdvocacyErrorEnhanced from 'components/Campaigns/RwdAdvocacy/AdvocacyViews/AdvocacyErrorEnhanced/AdvocacyErrorEnhanced';

export default AdvocacyErrorEnhanced;
